var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-bar-message",attrs:{"data-test":"notification-bar-message"}},[_c('base-icon',{staticClass:"notification-bar-message__icon",attrs:{"width":20,"height":20,"icon-fill":"stroke"}},[_c(_vm.componentName,{tag:"component"})],1),_vm._v(" "+_vm._s(_vm.notification.message)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }